module.exports = __webpack_public_path__ + "img/UTS3_106-2.ccbaa408.png";